// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/dietz-erweitert-seine-produktion-nasenbuegel-fuer-schutzmasken/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const dietzErweitertSeineProduktionNasenbuegelFuerSchutzmaskenDE: PageEntry = {
  id: "post.dietz-erweitert-seine-produktion-nasenbuegel-fuer-schutzmasken",
  locale: "de",
  slug: "dietz-erweitert-seine-produktion-nasenbuegel-fuer-schutzmasken",
  seo: {
    title: "DIETZ erweitert seine Produktion: Nasenbügel für Schutzmasken | Dietz GmbH",
    description: "DIETZ erweitert seine Produktion: Nasenbügel für Schutzmasken",
  },
  type: "post",
  h1: "DIETZ erweitert seine Produktion: Nasenbügel für Schutzmasken",
  blocks: [
    { kind: "heading", level: 2, text: "DIETZ erweitert seine Produktion: Nasenbügel für Schutzmasken" },
    { kind: "paragraph", text: "Im Rahmen der Corona-Krise nutzen wir unsere langjährige Erfahrung in der Herstellung von technischen Teilen für die Medizintechnik und haben unsere Produktion auf Nasenbügel für Mund-Nase-Schutzmasken erweitert." },
    { kind: "paragraph", text: "In gewohnt hochwertiger DIETZ-Qualität produzieren wir aus rostbeständigem Edelstahl. Die Nasenbügel sind gut biegsam, um vom Träger individuell an die Nasenform angepasst zu werden, und behalten ihre Form. Darüber hinaus sind die Kanten abgeschliffen, um Verletzungen zu vermeiden." },
    { kind: "paragraph", text: "Sie haben Interesse an Nasenbügeln für Ihre Schutzmasken? Weitere Infos zum Produkt sowie zu unserer Produktion erhalten Sie bei:" },
    { kind: "paragraph", text: "Mario Höfler" },
    { kind: "paragraph", text: "Technischer Vertriebsleiter" },
    { kind: "paragraph", text: "09568 9442-120" },
    { kind: "paragraph", text: "Mario.hoefler@dietz.eu" }
  ],
};
